var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChildNavigation',{attrs:{"currentView":_vm.view,"isDisabled":_vm.disablePath,"menuItems":_vm.menuItems}}),_c('div',{staticClass:"template__container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }